import { computed, makeObservable } from 'mobx';

import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

/**
 * Enum para opções de filtro de partes representadas por procuradorias.
 *
 * @readonly
 * @constant
 */
// prettier-ignore
const OPCOES_FILTRO_PROCURADORIA = {
    TODAS:              { id: 'TODAS',              descricao: 'Todas as partes representadas por procuradoria'          },
    NENHUMA:            { id: 'NENHUMA',            descricao: 'Todas as partes SEM representação por procuradoria'      },
    PELO_MENOS_UMA:     { id: 'PELO_MENOS_UMA',     descricao: 'Pelo menos uma parte representada por procuradoria'      },
    PELO_MENOS_UMA_SEM: { id: 'PELO_MENOS_UMA_SEM', descricao: 'Pelo menos uma parte SEM representação por procuradoria' }
};

export default class FiltroParteProcuradoriaPje extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = false;
    opcoesFiltro = Object.values(OPCOES_FILTRO_PROCURADORIA);

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    get label() {
        return 'Partes - Representação por procuradorias (PJe)';
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    get totalizador() {
        return [OPCOES_FILTRO_PROCURADORIA.NENHUMA.id, OPCOES_FILTRO_PROCURADORIA.PELO_MENOS_UMA.id];
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    getValorOpcao(registro) {
        if (!this.store.mapaProcessosPartes) {
            return [];
        }

        const partesProcesso = this.store.mapaProcessosPartes[registro.processo?.numeroCompleto];
        const partes = partesProcesso?.partes;

        if (!partes || partes.length === 0) {
            return [];
        }

        const totalPartes = partes.length;
        const totalComProcuradoria = partes.filter((parte) => parte.procuradoria).length;

        const subconjuntosAtendidos = [];

        // Nenhuma parte representada por procuradoria
        if (totalComProcuradoria === 0) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_PROCURADORIA.NENHUMA.id);
        }

        // Pelo menos uma parte representada por procuradoria
        if (totalComProcuradoria > 0) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_PROCURADORIA.PELO_MENOS_UMA.id);
        }

        // Todas as partes representadas por procuradoria
        if (totalComProcuradoria === totalPartes) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_PROCURADORIA.TODAS.id);
        }

        // Pelo menos uma parte SEM procuradoria (Inverso de "Todas as partes representadas por procuradoria")
        if (totalComProcuradoria < totalPartes) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_PROCURADORIA.PELO_MENOS_UMA_SEM.id);
        }

        return subconjuntosAtendidos;
    }

    getDescricao(valor) {
        const opcao = this.opcoesFiltro.find((opcao) => opcao.id === valor);
        return opcao ? opcao.descricao : 'INFORMAÇÃO DESCONHECIDA';
    }

    renderCarregando() {
        return this.renderCircularProgress('dados sobre representação por procuradoria...');
    }
}
